var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7919 17.5V24.7919M18.9581 24.7919V21.875M4.375 21.875L8.5022 17.7478M11.6669 10.2081C10.5066 10.2081 9.39378 10.6691 8.57331 11.4895C7.75284 12.31 7.2919 13.4228 7.2919 14.5831C7.2919 15.7435 7.75284 16.8562 8.57331 17.6767C9.39378 18.4972 10.5066 18.9581 11.6669 18.9581C12.8272 18.9581 13.94 18.4972 14.7605 17.6767C15.581 16.8562 16.0419 15.7435 16.0419 14.5831C16.0419 13.4228 15.581 12.31 14.7605 11.4895C13.94 10.6691 12.8272 10.2081 11.6669 10.2081Z",
    stroke: "#711371",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 4.375H29.1668C29.5535 4.375 29.9244 4.52862 30.1978 4.80207C30.4713 5.07551 30.6249 5.44639 30.6249 5.8331V29.1669C30.6249 29.5536 30.4713 29.9245 30.1978 30.1979C29.9244 30.4714 29.5535 30.625 29.1668 30.625H11.6668C11.4753 30.6251 11.2856 30.5874 11.1086 30.5142C10.9316 30.441 10.7708 30.3336 10.6353 30.1982C10.4999 30.0628 10.3924 29.902 10.3191 29.7251C10.2457 29.5481 10.208 29.3584 10.208 29.1669V24.7919",
    stroke: "#711371",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.636e430978ce96f48962e9b1e3c88d8f.svg";
export { ForwardRef as ReactComponent };